import Vue from 'vue';
import App from './App.vue';
import pinia from './store';
import router from './router';
import './utils/prepare';
import './router/guard';
import './styles';
import '@/icons'; // icon

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
  pinia,
  router
}).$mount('#app');
